module.exports = __webpack_public_path__ + "static/media/YF86_06.4bbe7d2e.jpg";